import * as S from './styles.styled'

// TheMenu
import { CircularLoader } from '@themenu/design-system'
import Portal from 'components/Portal'

interface Props {
  open: boolean
  invisible?: boolean
  relative?: boolean
}
export const BlockUI = ({ ...props }: Props) => {
  if (!props.open) {
    return null
  }

  return (
    <>
      {!props.relative ? (
        <Portal>
          <BlockUIContent {...props} />
        </Portal>
      ) : (
        <BlockUIContent {...props} />
      )}
    </>
  )
}

function BlockUIContent(props: Props) {
  return (
    <S.BlockUI data-testid="circular-loader" {...props}>
      <CircularLoader colorSet="default" size={64} />
    </S.BlockUI>
  )
}
